import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Text } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import BlockContent from '@sanity/block-content-to-react';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

//region styled

const StyledAccordionItem = styled(AccordionItem)`
  border: none;
`;

const StyledAccordionButton = styled(AccordionButton)`
  height: 60px;
  justify-content: space-between;
`;

//endregion

const ProjectDescriptionAccordion: FC<{ project?: Project }> = ({ project }) => {
  const { t } = useTranslation('projects');
  const ref = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (ref.current) {
      setHeight(ref.current.clientHeight);
    }
  }, [ref.current]);

  return (
    <>
      <Box ref={ref} pos="absolute" bottom="0" w="100%">
        <Accordion bg="white" allowToggle w="100%" defaultIndex={-1} className="accordion">
          <StyledAccordionItem>
            <StyledAccordionButton>
              <Text layerStyle="projects.descriptionAccordion.sectionTitle" as="h2" fontFamily="heading">
                {t('benefits')}
              </Text>
              <AccordionIcon />
            </StyledAccordionButton>
            <AccordionPanel>
              <Box layerStyle="projects.descriptionAccordion.descriptionText">
                <BlockContent blocks={project?.benefits} />
              </Box>
            </AccordionPanel>
          </StyledAccordionItem>
          <StyledAccordionItem>
            <StyledAccordionButton>
              <Text layerStyle="projects.descriptionAccordion.sectionTitle" as="h2" fontFamily="heading">
                {t('whyThisProject')}
              </Text>
              <AccordionIcon />
            </StyledAccordionButton>
            <AccordionPanel>
              <Box layerStyle="projects.descriptionAccordion.descriptionText">
                <BlockContent blocks={project?.whyThisProject} />
              </Box>
            </AccordionPanel>
          </StyledAccordionItem>
          <StyledAccordionItem>
            <StyledAccordionButton>
              <Text layerStyle="projects.descriptionAccordion.sectionTitle" as="h2" fontFamily="heading">
                {t('howItWorks')}
              </Text>
              <AccordionIcon />
            </StyledAccordionButton>
            <AccordionPanel>
              <Box layerStyle="projects.descriptionAccordion.descriptionText">
                <BlockContent blocks={project?.howItWorks} />
              </Box>
            </AccordionPanel>
          </StyledAccordionItem>
        </Accordion>
      </Box>
      <Box h={`${height}px`} />
    </>
  );
};

export default ProjectDescriptionAccordion;
